import { render, staticRenderFns } from "./ConsumptionWidgetInfo.vue?vue&type=template&id=23473ab0&scoped=true&lang=pug&"
import script from "./ConsumptionWidgetInfo.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionWidgetInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ConsumptionWidgetInfo.vue?vue&type=style&index=0&id=23473ab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23473ab0",
  null
  
)

export default component.exports